import React from "react";

interface StaffCardProps {
  id: number;
  staffMember: any;
}

const StaffCard: React.FC<StaffCardProps> = ({ staffMember }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col md:flex-row items-center md:items-start overflow-hidden h-full">
      {staffMember.imageUrl ? (
        <div className="flex-shrink-0">
          <img
            src={staffMember.imageUrl}
            alt={staffMember.name}
            className="w-[300px] h-[300px] object-cover"
          />
        </div>
      ) : (
        <div className="w-[300px] h-[300px] bg-gray-100 flex items-center justify-center text-gray-400">
          No image
        </div>
      )}
      <div className="p-6 flex flex-col justify-center text-center md:text-left h-full">
        <h5 className="text-xl font-bold text-gray-900 mb-1">{staffMember.name}</h5>
        <p className="text-lg text-gray-600 mb-4">{staffMember.position}</p>
        {staffMember.email && (
          <div className="mt-auto">
            <strong className="text-sm text-gray-500 break-all">
              {staffMember.email}
            </strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffCard;
